/**
 * SEO component - uses React 19's native document metadata support.
 * Any <title>, <meta>, <link>, or <script type="application/ld+json"> rendered
 * inside a component is automatically hoisted into <head>.
 */
const SITE_URL = "https://www.andamanavalon.com";
const DEFAULT_IMAGE = "https://www.andamanavalon.com/logo512.png";

const SEO = ({
  title,
  description,
  path = "",
  image = DEFAULT_IMAGE,
  type = "website",
  keywords,
  jsonLd,
  noindex = false,
}) => {
  const fullTitle = title
    ? `${title} | Andaman Avalon`
    : "Andaman Avalon | Luxury Andaman Tour Packages, Honeymoon & Family Trips";
  const desc =
    description ||
    "Andaman Avalon offers curated luxury tour packages for the Andaman Islands - honeymoon, family, adventure and budget trips to Port Blair, Havelock and Neil Island. Book online with instant confirmation.";
  const url = `${SITE_URL}${path}`;
  const kw =
    keywords ||
    "andaman tours, andaman travel agency, andaman tour package, andaman honeymoon, port blair tours, havelock island, neil island, andaman family package, andaman budget tour";

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <link rel="canonical" href={url} />

      {/* Open Graph (Facebook, LinkedIn, WhatsApp preview) */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Andaman Avalon" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
};

export const SITE_ORIGIN = SITE_URL;
export default SEO;
